import type CartPaymentInfo from "~/domains/payment/cart/CartPaymentInfo";
import type CartServiceInfo from "~/domains/payment/cart/CartServiceInfo";
import type DiscountInfo from "../../DiscountInfo";
import type { DiscountInfoType } from "../../DiscountInfoType";
import type ServiceDiscountStrategy from "./ServiceDiscountStrategy";
import { getNdcDiscountDescription, roundPrice } from "~/utils/payment";

export default class NdcUndefinedServiceDiscountStrategy implements ServiceDiscountStrategy {
  getDiscountInfoType(): DiscountInfoType {
    return "ndcUndefined";
  }

  getDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcUndefined",
      description: "",
      value: 0,
      amount: 0,
    };

    const ndcInfo = cartPaymentInfo.ndc;

    /* Undefined only applies if:
      - NDC pricingRule is not defined, but still has a defined priceRuleValue and product.id.
      - Defined product id is in cart.
      - This service is a seasonal service.
    */
    if (
      !ndcInfo?.pricingRule
      && ndcInfo?.product?.id === cartServiceInfo.ServiceDefId
      && !cartServiceInfo.isMonthly
      && !cartServiceInfo.isInitialPayment
    ) {
      const discountValue = roundPrice(ndcInfo.priceRuleValue ?? 0, "nearest", 2);

      discountInfo.description = `${getNdcDiscountDescription(ndcInfo)} - ${cartServiceInfo.ServiceName}`;
      discountInfo.value = discountValue;
      discountInfo.amount = discountValue;
      discountInfo.serviceDefId = cartServiceInfo.ServiceDefId;
    }

    return discountInfo;
  }

  getMonthlyDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcUndefined",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }

  getInitialPaymentDiscountInfo(cartServiceInfo: CartServiceInfo, cartPaymentInfo: CartPaymentInfo): DiscountInfo {
    const discountInfo: DiscountInfo = {
      type: "ndcUndefined",
      description: "",
      value: 0,
      amount: 0,
    };

    return discountInfo;
  }
}
